export type MunilyAreaPictureUploaderGallerySize = 'small' | 'large';

/** Carril horizontal: scroll nativo o flechas + desplazamiento programático. */
export type MunilyAreaPictureUploaderCarouselNavigation = 'scroll' | 'arrows';

export const MUNILY_APU_GALLERY_DEFAULTS = {
  size: 'large' as MunilyAreaPictureUploaderGallerySize,
  images: [] as string[],
  maxSlots: 5,
  disabled: false,
  /** Preferencias MIME para el diálogo de archivos (solo imágenes). */
  accept: 'image/*',
  /** Clave i18n para botón y aria-label del upload. */
  uploadLabelKey: 'commonComponents.areaPictureUploaderGallery.uploadLabel',
  carouselNavigation: 'scroll' as MunilyAreaPictureUploaderCarouselNavigation,
  dragDropEnabled: false,
} as const;
